﻿import {UIText} from "../Tools/Base/UIText";
import {UICommonPopup} from "../Tools/Base/UICommonPopup";
import {Core} from "../../Base/Core";
import {SlotItem} from "../../enums";
import {UISprite} from "../Tools/Base/UISprite";
import {UILabeledIcon} from "../Tools/Base/UILabeledIcon";
import {UINineSliceButton} from "../Tools/Base/UINineSliceButton";

export class UISpinsOffer extends UICommonPopup {

    get available() {
        return Core.Store.ProductAvailable("spins_offer_1") || Core.Store.ProductAvailable("spins_offer_2");
    }

    Awake() {
        super.Awake({
            title: Core.Localizator.Get("offer_spins_title"),
            closeButton: true,
            skin: "magenta",
        });

        this.onProductPurchased = this.onProductPurchased.bind(this);

        this.timerField = this.content.addChild(new UILabeledIcon({
            label: "",
            icon: "ico-clock",
            iconAlign: "absolute-left",
            iconSize: 1.2,
            backgroundColor: 0x000000,
            backgroundAlpha: 0.3,
            textProps: {
                fitTextTemplate: "00h 00m 00s"
            }
        }));
        this.spinsPicture = this.content.addChild(new UISprite("spin-icon"));
        this.description = this.content.addChild(new UILabeledIcon({
            label: Core.Localizator.Get("offer_spins_fullrestore"),
            icon: "spin-icon",
            iconSize: 1
        }));
        this.spinsNumberFld = this.content.addChild(new UIText());
        this.offerBtn = this.content.addChild(new UINineSliceButton("btn-orange"));

        this.endDateTime = 0;
        this.product = null;
    }

    Init() {
        super.Init();
        Core.Store.on("Purchased", this.onProductPurchased);
        this.offerBtn.on("pointertap", () => {
            Core.Store.BuyProductID(this.product.id);
        });
    }

    onProductPurchased(product) {
        if (product.id == "spins_offer_1" || product.id == "spins_offer_2") {
            this.Hide();
        }
    }

    Check() {
        if (!Core.Store.IsInitialized) return false;
        if (!this.available) return false;
        if (!Core.Time.Initialized) return false;
        if (!Core.Player.Initialized) return false;

        let offerInProgress = false;
        let offerFinished = false;

        if (Core.Player.Timers.spinsOfferTime != 0) {
            let offerStartTime = Core.Player.Timers.spinsOfferTime;
            this.endDateTime = offerStartTime + (Core.GameData.Gameplay.spinsOfferTimeMinutes * 60 * 1000);
            if (this.endDateTime < Core.Time.serverTime) {
                if (Core.Player.SpinsOfferType == SpinOfferType.FirstLevel1) {
                    Core.Player.SpinsOfferType = SpinOfferType.FirstLevel2;
                    Core.Player.SpinsUsed = 0;
                } else {
                    offerFinished = true;
                }
            } else {
                offerInProgress = true;
            }
        }

        if (offerInProgress || (Core.Player.SpinsNumber == 0 && Core.UI.slots.comboItem !== SlotItem.Spin && !offerFinished)) {
            if (Core.Player.SpinsUsed >= Core.GameData.Gameplay.spinsOfferThreshold3 && Core.Player.MaxSpinsBonus == Core.GameData.Gameplay.spinsOfferBonus1 && Core.Player.SpinsOfferType == SpinOfferType.Second) {
                this.ShowSecondOffer();
            } else if (Core.Player.SpinsUsed >= Core.GameData.Gameplay.spinsOfferThreshold1 && Core.Player.MaxSpinsBonus == 0 && Core.Player.SpinsOfferType == SpinOfferType.FirstLevel1) {
                this.ShowFirstOffer();
            } else if (Core.Player.SpinsUsed >= Core.GameData.Gameplay.spinsOfferThreshold2 && Core.Player.MaxSpinsBonus == 0 && Core.Player.SpinsOfferType == SpinOfferType.FirstLevel2) {
                this.ShowFirstOffer();
            } else {
                return false;
            }
        } else {
            return false;
        }
        return true;
    }

    ShowFirstOffer() {
        if (Core.Player.Timers.spinsOfferTime == 0) {
            Core.Player.Timers.spinsOfferTime = Core.Time.serverTime;
            Core.WaitBefore(2, () => {
                this.Show();
            });
        }
    }

    ShowSecondOffer() {
        if (Core.Player.Timers.spinsOfferTime == 0) {
            Core.Player.Timers.spinsOfferTime = Core.Time.serverTime;
            Core.WaitBefore(2, () => {
                this.Show();
            });
        }
    }

    _updateProductData() {
        if (Core.Player.SpinsOfferType == SpinOfferType.Second) {
            this.product = Core.Store.GetProduct("spins_offer_2");
            this.spinsNumberFld.text = Core.Localizator.Get("offer_spins_restorenumber", Core.GameData.Gameplay.spinsOfferBonus2);
        }
        else {
            this.product = Core.Store.GetProduct("spins_offer_1");
            this.spinsNumberFld.text = Core.Localizator.Get("offer_spins_restorenumber", Core.GameData.Gameplay.spinsOfferBonus1);
        }
        this.offerBtn.label = this.product.GetPrice();
    }

    Show() {
        if (!Core.Store.IsInitialized) return;
        if (!this.available) return;
        if (!Core.Time.Initialized) return;
        if (!Core.Player.Initialized) return;
        if (Core.Player.Timers.spinsOfferTime == 0) return;

        this.endDateTime = Core.Player.Timers.spinsOfferTime + (Core.GameData.Gameplay.spinsOfferTimeMinutes * 60 * 1000);
        if (this.endDateTime > Core.Time.serverTime) {
            this._updateProductData();
            this.Update();
            super.Show();
        }
    }

    fitLayout(viewport = Core.app.viewport) {
        this.setPopupSize(viewport.width * 0.8, viewport.height * 0.6);
        super.fitLayout(viewport);

        let contentRect = this.getContentSize();

        let timerRect = contentRect.clone().pad(-contentRect.width * 0.3, -contentRect.height * 0.475);
        timerRect.y = contentRect.height * 0.2;
        this.timerField.fitLayout(timerRect);

        let pictureRect = contentRect.clone().pad(0, -contentRect.height * 0.3);
        pictureRect.y = contentRect.height * 0.2;
        this.spinsPicture.fitRect(pictureRect);

        let descRect = contentRect.clone().pad(-contentRect.width * 0.05, -contentRect.height * 0.45);
        descRect.y = contentRect.height * 0.6;
        this.description.fitLayout(descRect);

        let numberRect = contentRect.clone().pad(-contentRect.width * 0.05, -contentRect.height * 0.45);
        numberRect.y = contentRect.height * 0.7;
        this.spinsNumberFld.fitLayout(numberRect);

        let buttonRect = contentRect.clone().pad(-contentRect.width * 0.3, -contentRect.height * 0.45);
        buttonRect.y = contentRect.bottom - contentRect.height * 0.15;
        this.offerBtn.fitLayout(buttonRect);
    }

    Update() {
        this.updateTime();
    }

    updateTime() {
        let timeLeft = this.endDateTime - Core.Time.serverTime;
        this.timerField.text = NUtils.FormatSecondsToTime(~~(timeLeft / 1000));
        if (timeLeft <= 0) this.Hide();
    }
}
